import React from 'react'

const Footer = () => {
    return (
        
<footer className={`p-4 shadow md:px-6 md:py-8 bg-gray-700`}>
<div className="sm:flex sm:items-center sm:justify-between">
<p className="flex items-center text-white mb-4 sm:mb-0 ">
    Nom du garage
</p>
<ul className="flex flex-wrap items-center mb-6 sm:mb-0">
<li>
<p className={`mr-4 text-sm   hover:underline md:mr-6 text-gray-400`}>Numero</p>
</li>
<li>
<a href="https://www.instagram.com/"  className={`mr-4 text-sm   hover:underline md:mr-6 text-gray-400`}>Instagram</a>
</li>
<li>
<a href="https://www.facebook.com/" className={`mr-4 text-sm   hover:underline md:mr-6 text-gray-400`}>Facebook</a>
</li>
</ul>
 </div>
<hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8"/>
<span className="block text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2022 <span className="hover:underline">Nom du garage™</span>. All Rights Reserved.
</span>
</footer>

    )
}

export default Footer